// extracted by mini-css-extract-plugin
export default {"dialog":"RegionSelection_tsx_dialog__7bTGk"};